<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" tip="正在提交数据....">
      <a-form class="ant-advanced-search-form">
        <a-row class="searchrow width-style-auto">
          <a-form-item :colon="false" label="审批状态">
            <a-select v-model="search.status" @change="searchAction">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.statues" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :colon="false" label="关键字">
            <a-input v-model="search.keyword" placeholder="请输入员工名称模糊检索"/>
          </a-form-item>
          <a-form-item>
            <a-button icon="search" @click="searchAction" style="margin-left: 10px">检索</a-button>
            <a-button type="primary" size="default" icon="plus-circle" style="margin-left: 10px" @click="addAction">新增</a-button>
            <a-button icon="lock" @click="lockeds()" style="margin-left: 10px">锁定</a-button>
            <a-button icon="check-circle" @click="unlock()" style="margin-left: 10px">解锁</a-button>
            <a-button icon="close-circle" @click="cancel()" style="margin-left: 10px">注销</a-button>
          </a-form-item>
        </a-row>
      </a-form>
      <a-row class="search"></a-row>
      <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true, selectedRowKeys: grid.selections, onChange: onSelectChange}" rowKey="doctorId" :dataSource="grid.data"
               :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
        <span slot="index" slot-scope="text, record, index">
           {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
        </span>
        <span slot="registerStatus" slot-scope="text, record, index">
          <a-tag v-if="record.registerStatus == 'APPROVED'" color="#108ee9">审批通过</a-tag>
          <a-tag v-if="record.registerStatus == 'NO_PASS'" color="#f50">未通过</a-tag>
          <a-tag v-if="record.registerStatus == 'WAIT_APPROVE'" color="red">待审批</a-tag>
          <a-tag v-if="record.registerStatus == 'NEW'">新注册</a-tag>
        </span>
        <span slot="status" slot-scope="text, record, index">
          <template v-if="record.qualified">
            <a-tag v-if="record.status == 'NORMAL'" color="#108ee9">正常</a-tag>
            <a-tag v-else-if="record.status == 'LOCKED'" color="#f50">锁定</a-tag>
            <a-tag v-else-if="record.status == 'CANCELLED'" color="red">注销</a-tag>
            <a-tag v-else>未知</a-tag>
          </template>
          <template v-else>
            <a-tag color="#f50">未审核</a-tag>
          </template>
        </span>
        <span slot="operate" slot-scope="text, record, index">
          <a href="javascript:;" @click="()=>editAction(record.id)">修改</a>
        </span>
      </a-table>
    </a-spin>
  </div>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { clearCookie, getCookie } from "@/api/cookie.js";
export default {
  name: "Doctor",
  data() {
    return {
      loading: false,
      current:{},
      init:{
        statues:[]
      },
      search:{
        keyword:'',
        status:''
      },
      grid: {
        loading: false,
        columns: columns,
        data: [],
        selections:[],
        pagination: this.$pagination
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "员工管理",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));
    this.getRegisterStatues(function (res) {
      self.init.statues = res;
    });

    this.searchAction();
  },
  methods:{
    addAction:function (){
      this.$router.push({ path : '/layout/system/doctor/create' });
    },
    editAction:function (id){
      this.$router.push({ path : '/layout/system/doctor/edit', query:{id:id} });
    },
    /**
     * 锁定
     */
    lockeds:function (){
      const self = this;
      if(null == this.grid.selections || this.grid.selections.length <= 0){
        self.$message.info({content: '请选择需要锁定的医生记录行.', duration: 2});
        return;
      }
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      if(this.current.doctor && (this.grid.selections||[]).includes(this.current.doctorId)){
        let modal = Modal.confirm({
          title: '是否对当前用户对应医生进行锁定操作,用户对应医生锁定将无法登录系统?',
          onOk() {
            modal.destroy();
            self.loading = true;
            self.$axios.post('/api/clinic/doctor/' + self.current.organId +'/lock', self.grid.selections).then(function (res) {
              self.loading = false;
              if(res.msg.flag == 0){
                self.$message.success({content: '医生锁定成功.', duration: 2});
                clearCookie();
                localStorage.removeItem("token");
                localStorage.removeItem("curruser");
                localStorage.removeItem("menus");
                localStorage.removeItem("currmenu");
                self.$message.success("已退出当前账号", 2);
                setTimeout(
                  function() {
                    self.$router.push("/login");
                  }.bind(self),
                   800);
              }else{
                self.$message.error({content: res.msg.message, duration: 2});
              }
            },function(res){
              self.loading = false;
            });
          }
        });
      }else{
        self.loading = true;
        self.$axios.post('/api/clinic/doctor/' + self.current.organId +'/lock', self.grid.selections).then(function (res) {
          self.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content: '医生锁定成功.', duration: 2});
            self.grid.selections = [];
            self.searchAction();//刷新列表
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(res){
          self.loading = false;
        });
      }
    },
    /**
     * 解锁
     */
    unlock:function (){
      const self = this;
      if(null == this.grid.selections || this.grid.selections.length <= 0){
        self.$message.info({content: '请选择需要解锁的医生记录行.', duration: 2});
        return;
      }
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      self.loading = true;
      self.$axios.post('/api/clinic/doctor/' + this.current.organId +'/unlock', self.grid.selections).then(function (res) {
        self.loading = false;
        if(res.msg.flag == 0){
          self.$message.success({content: '医生解锁成功.', duration: 2});
          self.grid.selections = [];
          self.searchAction();//刷新列表
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(res){
        self.loading = false;
      });
    },
    /**
     * 注销
     */
    cancel:function (){
      const self = this;
      if(null == this.grid.selections || this.grid.selections.length <= 0){
        self.$message.info({content: '请选择需要注销的医生记录行.', duration: 2});
        return;
      }
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      if(this.current.doctor && (this.grid.selections||[]).includes(this.current.doctorId)){
        let modal = Modal.confirm({
          title: '是否对当前用户对应医生进行注销操作,用户对应医生注销将无法登录系统?',
          onOk() {
            modal.destroy();
            self.loading = true;
            self.$axios.post('/api/clinic/doctor/' + self.current.organId +'/cancel', self.grid.selections).then(function (res) {
              self.loading = false;
              if(res.msg.flag == 0){
                self.$message.success({content: '医生注销成功.', duration: 2});
                clearCookie();
                localStorage.removeItem("token");
                localStorage.removeItem("curruser");
                localStorage.removeItem("menus");
                localStorage.removeItem("currmenu");
                self.$message.success("已退出当前账号", 2);
                setTimeout(
                        function() {
                          self.$router.push("/login");
                        }.bind(self),
                        800);
              }else{
                self.$message.error({content: res.msg.message, duration: 2});
              }
            },function(res){
              self.loading = false;
            });
          }
        });
      }else{
        self.loading = true;
        self.$axios.post('/api/clinic/doctor/' + this.current.organId +'/cancel', self.grid.selections).then(function (res) {
          self.loading = false;
          if(res.msg.flag == 0){
            self.$message.success({content: '医生注销成功.', duration: 2});
            self.grid.selections = [];
            self.searchAction();//刷新列表
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(res){
          self.loading = false;
        });
      }
    },
    buildParams:function (){
      return {
        'entity.organId':this.current.organId, 'entity.status' : this.search.status, 'entity.keyword' : this.search.keyword
      };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      if(undefined == this.current.organId || null == this.current.organId || '' == this.current.organId){
        self.$message.error({content: '当前用户无执业机构.', duration: 2});
        return;
      }
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid:function(params){
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/doctors', {params: params}).then(function(res){
        self.grid.loading = false;
        if(res.msg.flag == 0){
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          }else{
            Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.grid.loading = false;
      });
    },
    /**
     *  行选择事件
     */
    onSelectChange:function(selectedRowKeys){
      this.grid.selections = selectedRowKeys;
    }
  }
}
const columns=[
  {
    title: '序号',
    align: 'center',
    scopedSlots: {customRender: 'index'},
    width: 60
  },
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '身份证号',
    dataIndex: 'idcard',
    key: 'idcard',
    width: 200,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '性别',
    dataIndex: 'sexName',
    key: 'sexName',
    align: 'center',
    width: 80,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '所属科室',
    dataIndex: 'departmentName',
    key: 'departmentName',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '学历',
    dataIndex: 'educationName',
    key: 'educationName',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '加入时间',
    dataIndex: 'joinDate',
    key: 'joinDate',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '职务',
    dataIndex: 'job',
    key: 'job',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '职称',
    dataIndex: 'titleName',
    key: 'titleName',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '审批状态',
    align: 'center',
    dataIndex: 'registerStatusName',
    key: 'registerStatusName',
    width: 100,
    scopedSlots: {customRender: 'registerStatus'}
  },
  {
    title: '医生状态',
    align: 'center',
    dataIndex: 'statusName',
    key: 'statusName',
    width: 100,
    scopedSlots: {customRender: 'status'}
  },
  {
    title: '操作',
    key: 'id',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'operate'}
  }
  ];
</script>

<style scoped>

</style>
